import { actionType } from "..";
import { PROFILE_INFO, SIGN_IN, UPDATE_OUTOFOFFICE } from "../action-types/userActionTypes";

const userReducer = (state = {}, action: actionType) => {
    switch (action.type) {
        case SIGN_IN:
            return {
                ...state,
                ...Object.assign({}, action.payload)
            }
        case PROFILE_INFO:
            return {
                ...state,
                profileInfo: { ...action.payload }
            }
        case UPDATE_OUTOFOFFICE:
            return {
                ...state,
                outOfOfficeStatus: { ...action.payload }
            }
        default:
            return state;
    }
}

export default userReducer;